import apiClient from './index';
import type { LoginCredentials, AuthResponse } from '../types/auth';

export async function login(credentials: LoginCredentials): Promise<AuthResponse> {
  const response = await apiClient.post<AuthResponse>('/authenticate', credentials);
  return response.data;
}

export async function checkHealth(): Promise<boolean> {
  try {
    const response = await apiClient.get('/health');
    return response.data?.status === 'healthy';
  } catch {
    return false;
  }
}
